import React from "react";
import { useState } from "react";
import { useEditor } from "../../EditorContext";


function SubformEnum({control, formStructure}){

  const { updateFieldUiSchema, updateFieldSchema, updateFieldData } = useEditor()
  const [options, setOptions] = useState(['', ''])

  React.useEffect(() => {
    setOptions(control.schemaProps.enum)
  }, []);
  

  function UpdateOption (index, value) {
    let newOptions = structuredClone(options)
    newOptions[index] = value
    setOptions(newOptions)
    
    let inputObject = {
      id: "enum",
      value: newOptions
    }
    //console.log(inputObject)
    updateFieldSchema(formStructure, control.id, inputObject)
  }

  function AddOption (options) {
    let newOptions = structuredClone(options)
    newOptions.push('')
    setOptions(newOptions)
    // не вызываем updateFieldSchema, т.к. нет смысла менять schema пока вариант ответа пустой
  }

  function RemoveOption (options, index) {
    let newOptions = structuredClone(options)
    newOptions.splice(index, 1)
    setOptions(newOptions)

    let inputObject = {
      id: "enum",
      value: newOptions
    }
    updateFieldSchema(formStructure, control.id, inputObject)
  }

  let rows = []
  for (let i in options) {
    rows.push(
      <div 
        className="row mb-3" 
        key={control.id + '_option_' + i}
      >
        <div className="col-sm-4">
          <input
            id={i}
            type="text"
            className="form-control"
            value={options[i]}
            onChange={(e) => UpdateOption(i, e.target.value)}
            placeholder=""
          />
        </div>
        <div className="col-sm-1">
          { options.length > 2 ? 
            <button  className="btn editor-button mx-0 my-1 py-1" onClick={(e) => RemoveOption(options, i)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" className="bi bi-x-square" viewBox="0 0 17 17">
                <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
              </svg>
            </button>
          :
            <></>
          }
        </div>  
      </div>  
    )
  }

  return(
    <div className="form m-3">
      <label className="label mb-3">Варианты ответа:</label>
        {rows}
        { options.length < 50 ? 
          <button className="btn editor-button ms-0 m-1" onClick={() => AddOption(options)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-plus-square" viewBox="0 0 17 17">
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
            </svg>
          </button>
        :
          <></>
        }  
    </div>
  )
}

export default SubformEnum